module.exports = __webpack_public_path__ + "static/media/alert.356a3072.svg";